import { useEffect, useState } from "react";
import { USER_TYPE_CLIENTS, USER_TYPE_EMPLOYEES } from "src/constants/chat";

export const useActiveChats = (chatCollections) => {
    const [selectedChatListTypeOrLeadershipUuid, setSelectedChatListTypeOrLeadershipUuid] = useState(null);
    const [selectedChatListTypeOrLeadershipUuidLabel, setSelectedChatListTypeOrLeadershipUuidLabel] = useState(null);
    const [lookingForLeadershipToChat, setLookingForLeadershipToChat] = useState(null);

    const {
        populateActiveChatListDetails,
        isFetchingActiveChats,
        activeChatListDetails,
        setChatList,
        chatList,
        setActiveChatListDetails,
        leadershipRoles
    } = chatCollections;

    useEffect(() => {
        if (!activeChatListDetails || activeChatListDetails.length === 0) {
            return;
        }

        //onLoad
        const initPreselect = async () => {
            await selectIndexOfChatListDetails(activeChatListDetails[0].label);
        };

        if (!selectedChatListTypeOrLeadershipUuid) {
            initPreselect();
            return;
        }

        let existingChats = [];
        activeChatListDetails.forEach(chat => {
            existingChats = [...existingChats, ...chat.data.chats];
        });
        setChatList(existingChats);
    }, [activeChatListDetails]);

    useEffect(() => { 
        if (!selectedChatListTypeOrLeadershipUuid) {
            return;
        }
        selectIndexOfChatListDetails(selectedChatListTypeOrLeadershipUuid);

    }, [selectedChatListTypeOrLeadershipUuid]);

    const selectIndexOfChatListDetails = async (activeChatListDetailsLabel) => {
        const foundChat = activeChatListDetails.find(chat => chat.label === activeChatListDetailsLabel);
        if (!foundChat) {
            console.warn("Chat List details not found", activeChatListDetails, activeChatListDetailsLabel);
            return;
        }

        setChatList(foundChat.data.chats);
        handleChatListSelectLabelAndUuid(foundChat.label);
    };

    /**
     * @var {string} selectedValue - can be employees, clients, or available leadershipRoleUuid
     */
    const handleChatListSelectLabelAndUuid = (selectedValue) => {
        setLookingForLeadershipToChat(null);
        const foundChat = activeChatListDetails.find(chat => chat.label === selectedValue);
        if (!foundChat) {
            console.warn("Chat List details for selected value not found", selectedValue, activeChatListDetails);
            return;
        }

        const isNonLeadership = [USER_TYPE_CLIENTS, USER_TYPE_EMPLOYEES].includes(selectedValue);
        
        if (isNonLeadership) {
            setSelectedChatListTypeOrLeadershipUuid(selectedValue);
            setSelectedChatListTypeOrLeadershipUuidLabel(selectedValue);
            return;
        }

        if (Array.isArray(leadershipRoles)) {
            const selectedLeadershipRoleItem = leadershipRoles.find((item) => item.uuid === selectedValue);
            if (!selectedLeadershipRoleItem) {
                console.warn("Unknown Leadership Role in Active Chat List has been selected: ", selectedValue, leadershipRoles);
                return;
            }

            const selectedLeadershipRoleName = selectedLeadershipRoleItem.name;
            setSelectedChatListTypeOrLeadershipUuid(selectedValue);
            setSelectedChatListTypeOrLeadershipUuidLabel(selectedLeadershipRoleName);

            //check if this is a leadership and has no chat, let's show active leaders
            if (foundChat.data.chats.length === 0) {
                setLookingForLeadershipToChat(selectedLeadershipRoleItem);
                return;
            }

            return;
        }

        console.warn("Unknown Active Chat List has been selected: ", selectedValue, leadershipRoles);
    };

    const handleChatListSelectChange = (selectedValue) => {
        handleChatListSelectLabelAndUuid(selectedValue);
    };

    const removeRoomInActiveChatListDetails = async (roomId) => {
        const getUpdatedActiveChatlistDetailsForRemovingARoom = (prevActiveChatListDetails) => {
            const activeCopy = prevActiveChatListDetails ?? [];
            
            return activeCopy.map(item => {
                const updatedChats = item.data.chats.filter(chat => chat.matrixRoomId !== roomId);
                
                // Important: Create a *new* object with the updated chats array
                return {
                    ...item, // Copy other properties of the item
                    data: {
                        ...item.data, // Copy other properties of the data object
                        chats: updatedChats // Replace the chats array with the filtered one
                    }
                };
            });
        };

        setActiveChatListDetails((prevActiveChatListDetails) => {
            return getUpdatedActiveChatlistDetailsForRemovingARoom(prevActiveChatListDetails);
        });
    };

    return {
        populateActiveChatListDetails,
        selectedChatListTypeOrLeadershipUuid,
        selectedChatListTypeOrLeadershipUuidLabel,
        activeChatListDetails,
        isFetchingActiveChats,
        handleChatListSelectChange,
        chatList,
        leadershipRoles,
        lookingForLeadershipToChat,
        setLookingForLeadershipToChat,
        removeRoomInActiveChatListDetails
    };
};